import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const deliverables = ['El Manual "Prompt Engineering Real-Life" (Guía PDF Completa).', 'El Framework Maestro C-R-T-R explicado paso a paso.', 'La Técnica del "Espejo de Identidad" para que la IA diseñe tus proyectos por ti.', 'Listas de Comandos de Refinamiento de 10 segundos para mejorar cualquier texto.', 'Biblioteca de Scripts de Emergencia para oficina, ventas y aprendizaje.', 'Checklist de "Pre-Vuelo" para eliminar el ruido robótico antes de dar Enter.'];
export function WhatYouGet() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-800/30 border-y border-white/5" data-id="element-157">
      <div className="max-w-4xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-160">
            Lo Que Recibes
          </h2>
        </motion.div>

        <div className="glass-card rounded-3xl p-8 md:p-12" data-id="element-161">
          <div className="space-y-6" data-id="element-162">
            {deliverables.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center group" data-id="element-163">
                <div className="flex-shrink-0 mr-4" data-id="element-164">
                  <CheckCircle2Icon className="w-6 h-6 text-cyan-accent group-hover:text-cyan-glow group-hover:scale-110 transition-all" data-id="element-165" />
                </div>
                <p className="text-lg text-gray-200 group-hover:text-white transition-colors" data-id="element-166">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}